import { CartState } from "src/types/cartTypes";

const selectTotalPrice = ({ cart }: { cart: CartState }) => cart.totalPrice;

const selectTotalCartQuantity = ({ cart }: { cart: CartState }) =>
  cart.totalQuantity;

const selectCartItems = ({ cart }: { cart: CartState }) => cart.items;

const selectCart = ({ cart }: { cart: CartState }) => cart;

const selectTax = ({ cart }: { cart: CartState }) => cart.tax;

const selectDiscount = ({ cart }: { cart: CartState }) => cart.discount;

const selectCouponCode = ({ cart }: { cart: CartState }) => cart.couponCode;

const selectErrorMessage = ({ cart }: { cart: CartState }) => cart.couponError;

const selectRefreshCart = ({ cart }: { cart: CartState }) => cart.refreshCart;

export {
  selectTotalCartQuantity,
  selectCartItems,
  selectTotalPrice,
  selectCart,
  selectTax,
  selectDiscount,
  selectCouponCode,
  selectErrorMessage,
  selectRefreshCart,
};
